import $ from 'jquery';

export default {
  init () {
    $('.js-scrollto').click(function() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return false;
    }) 
  },
};